import { render, staticRenderFns } from "./ModalSendProcess.vue?vue&type=template&id=2c7f0dc4"
import script from "./ModalSendProcess.vue?vue&type=script&lang=js"
export * from "./ModalSendProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports